'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { NotificationBell } from '@/features/notification-bell/components';
import type { NotificacaoItem } from '@/types/notificationBell/types';
import { rotaDoAvisoDaEquipeInterna } from '../../utils/rotaDoAvisoDaEquipeInterna';

/**
 * Barra superior do painel admin, hoje só com o sino da equipe interna. Mesma altura e borda do
 * header da home (`h-16`), de propósito: o editor de fluxos arbitrais já descontava 64px de
 * header (`h-[calc(100vh-64px)]`) e passa a caber exato.
 */
export function AdminTopbar() {
  const $ = _c(4);
  const router = useRouter();
  let t0;
  if ($[0] !== router) {
    t0 = item => {
      const rota = rotaDoAvisoDaEquipeInterna(item);
      if (rota) {
        router.push(rota);
      }
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleAvisoClicado = t0;
  let t1;
  if ($[2] !== handleAvisoClicado) {
    t1 = <header className="flex h-16 w-full shrink-0 items-center justify-end border-b border-neutral-200 bg-white px-4 sm:px-6 xl:px-8"><NotificationBell fonte="equipeInterna" onItemClick={handleAvisoClicado} itemAtivavel={_temp} /></header>;
    $[2] = handleAvisoClicado;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function _temp(item_0) {
  return rotaDoAvisoDaEquipeInterna(item_0) !== null;
}